import { cva } from "cva";

export const navbarMenuStyles = cva({
  base: "bg-surface rounded-default p-md relative flex flex-col gap-y-8 list-none after:content-[''] after:absolute after:block after:w-full after:h-20 after:bottom-full after:left-0 after:bg-transparent after:-z-1",
});

export const navbarMenuTriggerStyles = cva({
  base: [
    "cursor-pointer py-10 px-16 text-ginto-15 font-normal leading-140 rounded-sm flex items-center gap-x-4 text-content-primary transition-colors duration-550 ease-spring",
    "[&>svg]:w-12 [&>svg]:h-12 [&>svg]:fill-current [&>svg]:transition-transform [&>svg]:duration-550 [&>svg]:ease-spring motion-reduce:[&>svg]:transition-none",
  ],
  variants: {
    isOpen: {
      true: "bg-ink-100 [&>svg]:-rotate-180",
      false: "bg-transparent hover:bg-ink-100 focus-visible:bg-ink-100",
    },
  },
});
